import { ProductAnnotationData } from "@vviinn/user-managment-client-ts";
import { AnnotationFields } from "./types";

export const productMutableFields =
  ProductAnnotationData.getAttributeTypeMap().filter(
    ({ name }) => name !== "id",
  ) as {
    name: AnnotationFields;
    baseName: string;
    type: string;
  }[];
